"use client";

import { c as _c } from "react/compiler-runtime";
import Button from "@/app/components/UI/Button";
import React, { ReactNode } from "react";
import cn from "@/app/utils/cn";
import { handleLoginRedirect } from "@/app/utils/handleLoginRedirect";
import { useRouter } from "@/app/hooks/useRouter";
import isMobileView from "@/app/utils/isMobileView";
type MainHeroProps = {
  backgroundClassName: string;
  title: string;
  text: string;
  buttonText?: string;
  showButton?: boolean;
  isLogin?: boolean;
  children?: ReactNode;
  customContainerStyle?: string;
  customeContentStyle?: string;
  customTitletStyle?: string;
  customTextStyle?: string;
  onButtonClick?: () => void;
};
export default function MainHero(t0) {
  const $ = _c(32);
  const {
    backgroundClassName,
    title,
    text,
    buttonText,
    showButton,
    isLogin,
    children,
    customContainerStyle,
    customeContentStyle,
    onButtonClick,
    customTitletStyle,
    customTextStyle
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = () => {
      handleLoginRedirect({
        router
      });
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLogin = t1;
  const handleButtonClick = onButtonClick ?? handleLogin;
  const isButtonVisible = showButton ?? !isLogin;
  const resolvedBackgroundClassName = backgroundClassName ? `${backgroundClassName} ${"rounded-3xl h-[220px] md:h-[372px] px-4 md:px-8 xl:px-16 py-4 md:py-7"}` : "rounded-3xl h-[220px] md:h-[372px] px-4 md:px-8 xl:px-16 py-4 md:py-7";
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== customContainerStyle || $[3] !== customTextStyle || $[4] !== customTitletStyle || $[5] !== customeContentStyle || $[6] !== resolvedBackgroundClassName || $[7] !== title) {
    const variantClasses = {
      containerClassName: "custom-container pt-20 md:pt-0",
      contentClassName: "flex flex-col justify-center h-full max-w-[148px] md:max-w-[460px]",
      titleClassName: "text-charcoal-900 text-base md:text-xl lg:text-[28px] font-semibold md:font-bold max-w-[460px] leading-[150%] md:leading-[200%]",
      textClassName: "mt-1 md:mt-3 text-charcoal-600 text-[11px] md:text-sm lg:text-base"
    };
    const classes = variantClasses;
    t6 = cn(classes.containerClassName, customContainerStyle);
    t5 = resolvedBackgroundClassName;
    t3 = cn(classes.contentClassName, customeContentStyle);
    t4 = <h1 className={cn(classes.titleClassName, customTitletStyle)}>{title}</h1>;
    t2 = cn(classes.textClassName, customTextStyle);
    $[2] = customContainerStyle;
    $[3] = customTextStyle;
    $[4] = customTitletStyle;
    $[5] = customeContentStyle;
    $[6] = resolvedBackgroundClassName;
    $[7] = title;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== text) {
    t7 = <p className={t2}>{text}</p>;
    $[13] = t2;
    $[14] = text;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== buttonText || $[17] !== handleButtonClick || $[18] !== isButtonVisible) {
    t8 = isButtonVisible && <div className="mt-3 md:mt-8 w-fit"><Button variant="solid" color="primary" size={isMobileView ? "xs" : "lg"} onClick={handleButtonClick}>{buttonText}</Button></div>;
    $[16] = buttonText;
    $[17] = handleButtonClick;
    $[18] = isButtonVisible;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== children || $[21] !== t3 || $[22] !== t4 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t3}>{t4}{t7}{t8}{children}</div>;
    $[20] = children;
    $[21] = t3;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[26] = t5;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t6) {
    t11 = <div className={t6}>{t10}</div>;
    $[29] = t10;
    $[30] = t6;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}